import { get } from '@classic/Foundation/Services/ApiService'
import { getKambiPendingBetHistory } from '@core/Areas/Kambi/helpers/api/player'

// ======
// Racing
// ======

export type PendingTicketsCountResponse = { pendingTicketsCount?: number }

export const fetchRacePendingTicketsCount = () =>
  get<PendingTicketsCountResponse>({
    url: '/$_/accountActivity/tickets/pending/count',
  })

// =====
// Kambi
// =====

export type KambiPendingTicketsCountResponse = number | null

export const fetchKambiPendingTicketCount = async () => {
  try {
    const response = await getKambiPendingBetHistory()

    return response?.range.size
  } catch {
    return null
  }
}
